import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Hub from "@/pages/Hub";
import ShopConcept from "@/pages/ShopConcept";
import ShopBuild from "@/pages/ShopBuild";
import ShopInterior from "@/pages/ShopInterior";
import ShopBrief from "@/pages/ShopBrief";
import ShopIP from "@/pages/ShopIP";
import ShopTeaser from "@/pages/ShopTeaser";
import ShopMobile from "@/pages/ShopMobile";
import Software from "@/pages/Software";
import TechApp from "@/tech/TechApp";
import DesignStudio from "@/pages/DesignStudio";
import { PinProvider } from "@/software/PinGate";
import Home from "@/pages/Home";
import Proposal from "@/pages/Proposal";
import Manufacturer from "@/pages/Manufacturer";
import AccessCenter from "@/pages/AccessCenter";
import AcceptDoc from "@/pages/AcceptDoc";
import SetPassword from "@/pages/SetPassword";
import NdaGate from "@/components/NdaGate";
import AdminOnly from "@/components/AdminOnly";
import AudienceGate from "@/components/AudienceGate";

function App() {
  return (
    <BrowserRouter>
      <Toaster richColors position="top-right" />
      <NdaGate>
        <Routes>
          <Route path="/" element={<Hub />} />
          <Route path="/proposal" element={<AudienceGate allow={["investor"]} label="the investor proposal"><Proposal /></AudienceGate>} />
          <Route path="/manufacturer" element={<AudienceGate allow={["manufacturer"]} label="the manufacturer view"><Manufacturer /></AudienceGate>} />
          <Route path="/admin/views" element={<AdminOnly title="Access &amp; Views — admin only"><AccessCenter /></AdminOnly>} />
          <Route path="/shop" element={<ShopConcept />} />
          <Route path="/shop/analyzer" element={<Navigate to="/software" replace />} />
          <Route path="/shop/build" element={<AudienceGate allow={["manufacturer"]} label="the manufacturer view"><ShopBuild /></AudienceGate>} />
          <Route path="/shop/interior" element={<AudienceGate allow={["manufacturer"]} label="the manufacturer view"><ShopInterior /></AudienceGate>} />
          <Route path="/shop/brief" element={<AudienceGate allow={["manufacturer"]} label="the manufacturer view"><ShopBrief /></AudienceGate>} />
          <Route path="/shop/ip" element={<ShopIP />} />
          <Route path="/shop/teaser" element={<ShopTeaser />} />
          <Route path="/software" element={<PinProvider><Software /></PinProvider>} />
          <Route path="/pool-tech" element={<TechApp />} />
          <Route path="/tech" element={<Navigate to="/pool-tech" replace />} />
          <Route path="/design-studio" element={<DesignStudio />} />
          <Route path="/mobile" element={<ShopMobile />} />
          <Route path="/home" element={<Home />} />
          <Route path="/accept/:docType/:docId" element={<AcceptDoc />} />
          <Route path="/set-password/:token" element={<SetPassword />} />
        </Routes>
      </NdaGate>
    </BrowserRouter>
  );
}

export default App;
